import { HFlow, Text, Theme, useStyles, VFlow } from 'bold-ui'
import { isString } from 'lodash'
import React, { CSSProperties } from 'react'

interface IconTextCardProps {
  icon?: React.ReactElement
  iconColor?: string
  label?: string
  value?: string | React.ReactElement
}

export const IconTextCard = (props: IconTextCardProps) => {
  const { icon, iconColor, label, value } = props
  const { classes } = useStyles(createStyles)
  return (
    <>
      {value && (
        <HFlow hSpacing={0.5}>
          {React.cloneElement(icon, { style: { color: `${iconColor}`, flexShrink: 0 } })}
          <VFlow vSpacing={0}>
            <HFlow>
              {label && <Text className={classes.title}>{`${label}:`}</Text>}
              {isString(value) ? <Text className={classes.content}>{value}</Text> : value}
            </HFlow>
          </VFlow>
        </HFlow>
      )}
    </>
  )
}

export const createStyles = (theme: Theme) => ({
  title: {
    fontWeight: 'bold',
    marginRight: '0.375rem',
  } as CSSProperties,
  content: {
    [theme.breakpoints.down('lg')]: {
      display: 'block',
    },
  } as CSSProperties,
})
